import { pass } from '#general/lib/forms'

const passwordTests = {
  'password should be 8 characters minimum' (password = '') { return password.length < 8 },
  // Mirroring password maximum length on server, set to prevent hashing exhaustion
  // See https://instatunnel.my/blog/the-1mb-password-crashing-backends-via-hashing-exhaustion
  'password should be 256 characters maximum' (password = '') { return password.length > 256 },
}

export function testPassword (password: string = '') {
  return pass({
    value: password,
    tests: passwordTests,
  })
}

export default {
  pass: testPassword,
}
